import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";

// const LEGAL_LINKS = {
//   privacy:
//     "https://csappproduction-storage.s3.ap-south-1.amazonaws.com/static-assets/legal/HYNT_Privacy+Policy.pdf",
//   cookie:
//     "https://csappproduction-storage.s3.ap-south-1.amazonaws.com/static-assets/legal/Cookie+Policy.pdf",
//   terms:
//     "https://csappproduction-storage.s3.ap-south-1.amazonaws.com/static-assets/legal/HYNT+terms.pdf",
// };

function RevampFooter({ hideCta = false }) {
  return (
    <footer className="revamp-site-footer" aria-label="Site footer">
      {!hideCta && (
        <section className="revamp-footer-cta-shell" aria-label="Get started">
          <div className="revamp-footer-cta">
            <div className="revamp-footer-cta-copy">
              <p className="revamp-footer-cta-kicker">— GET STARTED</p>
              <h2 className="revamp-footer-cta-title">
                Your home journey
                <br />
                starts <span className="revamp-footer-cta-accent">here.</span>
              </h2>
            </div>

            <div className="revamp-footer-cta-actions">
              <Link to="/enquiry" className="revamp-footer-cta-btn revamp-footer-cta-btn-primary">
                Post a requirement
              </Link>
              <Link
                to="/create-business/category"
                className="revamp-footer-cta-btn revamp-footer-cta-btn-secondary"
              >
                I have a business
              </Link>
            </div>
          </div>
        </section>
      )}

      <section className="revamp-footer-main-shell">
        <div className="revamp-footer-main">
          <div className="revamp-footer-brand">
            <Link to="/"><img className="revamp-footer-logo" src={Logo} alt="HYNT logo" /></Link>
            <p className="revamp-footer-brand-copy">
              India&apos;s Home App. The ecosystem where homeowners, professionals, and brands come
              together to build something beautiful.
            </p>
          </div>

          <div className="revamp-footer-links">
            <div className="revamp-footer-col">
              <div className="revamp-footer-col-title">FOR HOMEOWNERS</div>
              <Link to="/enquiry" className="revamp-footer-link">
                Post a Requirement
              </Link>
            </div>

            <div className="revamp-footer-col">
              <div className="revamp-footer-col-title">FOR PROFESSIONALS</div>
              <Link to="/create-business/category" className="revamp-footer-link">
                List your business
              </Link>
            </div>

            <div className="revamp-footer-col">
              <div className="revamp-footer-col-title">COMPANY</div>
              <Link to="/careers" className="revamp-footer-link">
                Careers
              </Link>
              <Link to="/contact" className="revamp-footer-link">
                Contact Us
              </Link>
              <Link to="/privacy-policy" className="revamp-footer-link">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="revamp-footer-link">
                Cookie Policy
              </Link>
              <Link to="/terms" className="revamp-footer-link">
                Terms of service
              </Link>
              <Link to="/takedown-policy" className="revamp-footer-link">
                Takedown Policy
              </Link>
            </div>
          </div>
        </div>

        <div className="revamp-footer-bottom">
          <small className="revamp-footer-muted">
            © {new Date().getFullYear()} HYNT Solutions Pvt. Ltd. All
            <br className="revamp-footer-break" />
            rights reserved.
          </small>

          <div className="revamp-footer-socials">
            <a href="https://www.instagram.com/gethynt_/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="revamp-footer-social-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
            <a href="https://www.linkedin.com/company/hynt-india/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="revamp-footer-social-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
            <a href="https://www.facebook.com/hynt.india" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="revamp-footer-social-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.hynt.app" target="_blank" rel="noopener noreferrer" aria-label="Google Play" className="revamp-footer-social-link">
              <svg width="18" height="18" viewBox="0 0 512 512" fill="currentColor"><path d="M48 59.49v393a4.33 4.33 0 007.37 3.07L260 256 55.37 56.42A4.33 4.33 0 0048 59.49zM345.8 174L89.22 32.64l-.16-.09c-4.42-2.4-8.62 3.58-5 7.06L285.19 231.89zM84.08 472.39c-3.64 3.48.56 9.46 5 7.06l.16-.09L345.8 338l-60.61-57.89zM449.38 231l-71.65-39.46L310.36 256l67.37 64.43L449.38 281c19.49-10.77 19.49-39.23 0-50z"/></svg>
            </a>
            <a href="https://apps.apple.com/in/app/hynt-for-everything-home/id6752606030" target="_blank" rel="noopener noreferrer" aria-label="App Store" className="revamp-footer-social-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            </a>
          </div>

          <small className="revamp-footer-muted revamp-footer-made">
            Made with <span className="revamp-footer-heart" aria-hidden="true">♥</span> in India
          </small>
        </div>
      </section>
    </footer>
  );
}

export default RevampFooter;

